<template>
  <div
    class="p-3 p-md-5"
    :class="propWhiteBackground ? 'bg-white' : ''"
    v-if="highlightsList.length"
    style="border-radius: 10px;"
  >
    <div :class="propFullwidth ? '' : 'mx-auto custom-width'">
      <!-- Title -->
      <div class="text-center">
        <div class="position-relative text-center mt-md-4 mt-5" style="min-height: 50px;">
          <h1 class="section-bg-title">Évènements & Actualités</h1>
          <h4 class="section-bg-sub-title font-weight-bold position-relative mb-0" style="z-index: 1;">
            Restez informé de nos nouveautés
          </h4>
        </div>

        <hr class="mx-auto" style="width: 40px; border-top: 2px solid #ced4da;" />
      </div>

      <Splide :key="splideKey"
        v-if="highlightsList"
        ref="splideRef"
        :options="this.splideOptions"
      >
      <SplideSlide v-for="announcement in highlightsList" :key="announcement.id">
        <div>

          <div class="item-modal-img mx-auto m-4" style="width: min(500px, 100vw);">
            <div style="padding-bottom: 124%; position: relative;">
              <img
                :src="`/api/image/get/${announcement.image}`"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"
              />
            </div>
          </div>

           <div id="annoucement-title-small" v-if="propDisplayTitle" class="col-12 mt-5 text-center">
              <h4 :title="announcement.title" class="text-primary mb-0 pb-0 text-uppercase font-weight-bold">{{announcement.title}} </h4>
            </div>

          <div v-html="announcement.description" class="p-3" style="color: #000 !important;"/>

          <div class="justify-content-between row text-dark  mt-auto align-items-center mb-md-0 mb-5" style="width: 95%;">
           <div v-if="propDisplayTitle" class="col-6 mt-2 pt-1 pl-1 font-weight-bold text-left ">
              <i class="bx bx-calendar me-1"></i> {{announcement.date}}
            </div>

            <div v-if="propDisplayTitle" class="col-6 mt-2 pt-1 pl-1 text-right font-size-16">
              <span v-if="announcement.tag" class="badge bg-primary text-white ">
                <strong>{{announcement.tag}}</strong> 
              </span>
            </div> 
          </div>

        </div>



        </SplideSlide>
      </Splide>


    </div>
  </div>
</template>

<script>
import AnnouncementsApi from "@/services/announcements-api";


import { Splide, SplideSlide } from '@splidejs/vue-splide';

export default {
  props: {
    propDisplayTitle: { type: Boolean, default: true },
    propWhiteBackground: { type: Boolean, default: true },
    propFullwidth: { type: Boolean, default: false },
  },
  components: {
    Splide, SplideSlide
  },
  data() {
    return {
      highlightsList: [],
      expandedItems: [],
      splideOptions:{
          type: 'loop',
          drag: true,
          arrows: true,
          pagination: true,
          perPage: 1,
          focus: 'center',
          gap: '1rem',
          autoWidth: false,
          autoHeight: true,
          rewind: true,
        },
        splideKey:0

    };
  },
  mounted() {
    this.getHighlights();
    window.addEventListener('resize', this.updateSliderType);

  },

  beforeUnmount() {
    window.removeEventListener('resize', this.updateSliderType);
  },

  computed: {
    hasMultipleImages() {
      return this.highlightsList && this.highlightsList.length > 1;
    },
  },

  methods: {

    updateSliderType() {
      const width = window.innerWidth;
      if (width >= 500 && width < 1400) {
        this.splideOptions.type = 'fade';
      } else {
        this.splideOptions.type = 'loop';
      }
      this.splideKey++
    },

    getHighlights() {
      AnnouncementsApi.getHighlights(1, 100).then((result) => {
        if (result) this.highlightsList = result.list;
      });
    },

      shouldShowReadMore(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      const text = div.innerText || div.textContent || "";
      const lineCount = Math.ceil(text.length / 100);
      return lineCount > 5;
    },

    toggleDescription(id) {
      const index = this.expandedItems.indexOf(id);
      if (index === -1) {
        this.expandedItems.push(id);
      } else {
        this.expandedItems.splice(index, 1);
      }
    },
  },
  
  
};

</script>

<style scoped>
.custom-width {
  width: 90%;
}
@media (min-width: 992px) {
  .custom-width {
    width: 80%;
  }
}

.card-title {
  font-size: 1rem;
}

.card-text {
  font-size: 0.875rem;
}

.owl-carousel .owl-item {
  display: flex;
  height: 100%;
}

.owl-carousel .card {
  flex: 1;
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.owl-carousel .card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.top-left {
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  border-top-left-radius: 6px;
  border-bottom-right-radius: 10px;
}

.top-right {
  top: 0;
  right: 0;
}

.limited-lines {
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.875rem;
}

::v-deep .splide__pagination {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

::v-deep .splide__pagination__page {
  background: #ccc;
  width: 8px;
  height: 8px;
  margin: 0 5px;
  border-radius: 50%;
  opacity: 1;
  transition: background-color 0.3s ease;
  border: none;
}

::v-deep .splide__pagination__page.is-active {
  background: #223c8a ;
}


::v-deep .splide__arrow {
  pointer-events: all;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 20;
  border: none;
  background: none;
  cursor: pointer;
  

}

@media (max-width: 575.98px) {
  ::v-deep .splide__arrow {
    display: none !important;
  }
}

::v-deep .splide__arrow--prev {
  left: 10px;
}
::v-deep .splide__arrow--next {
  right: 10px;
}


.item-modal-img{
  width: 100%;
  height: auto;
}

.section-bg-title {
  font-size: 1.6rem;
  color: rgba(0, 0, 0, 0.05); /* Faint gray */
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -60%);
  /* margin: 0; */
  z-index: 0;
  pointer-events: none;
  font-style: italic;
  font-weight: bold;
  white-space: nowrap;
}

/* Medium screens (≥768px) */
@media (min-width: 600px) {
  .section-bg-title {
    font-size: 2.8rem;
  }
}

/* Large screens (≥992px) */
@media (min-width: 992px) {
  .section-bg-title {
    font-size: 3rem;
  }
}

/* Extra large screens (≥1200px) */
@media (min-width: 1200px) {
  .section-bg-title {
    font-size: 4rem;
  }
}


.section-bg-sub-title {
  font-size: 1rem;
}

/* Medium screens (≥768px) */
@media (min-width: 768px) {
  .section-bg-sub-title {
    font-size: 1.1rem;
  }
}

/* Large screens (≥992px) */
@media (min-width: 992px) {
  .section-bg-sub-title {
    font-size: 1.3rem;
  }
}

/* Extra large screens (≥1200px) */
@media (min-width: 1200px) {
  .section-bg-sub-title {
    font-size: 1.5rem;
  }
}


</style>
